export default {
  humanTraining_introduction: '介紹',
  humanTraining_catalog: '目錄({resourcesCount})',
  humanTraining_leran_rules: '完成規則',
  humanTraining_training_no_start: '培訓項目暫未開始!',
  humanTraining_course_duration: '課程學時',
  humanTraining_duration: '學時',
  humanTraining_have_duration: '已獲得學時',
  humanTraining_valid_duration: '未獲得',
  humanTraining_resource_duration: '資源學時：',
  humanTraining_own_duration: '已獲得學時：',
  humanTraining_book_title_mark1: '《',
  humanTraining_book_title_mark2: '》',
  humanTraining_examScore: '考試成績 {examScore}分/{totalScore}分',
  humanTraining_endDays: '距離考試截止 {endDays}天',
  humanTraining_end_todays: '考試截止今天結束',
  humanTraining_test_num: '共{testNum}題',
  humanTraining_service_error: '服務錯誤！',
  humanTraining_live_status: '培訓項目暫不支持觀看回放',
  humanTraining_total_period: '完成',
  humanTraining_online_period: '完成線上',
  humanTraining_offline_period: '完成線下',
  humanTraining_go_learn: '去學習',
  humanTraining_no_rules: '還沒有規則',
  humanTraining_exam_tasks: '考試任務',
  humanTraining_past: '通過{examName}',
  humanTraining_residualExamNum: '分通過（共{residualExamNum}次機會）',
  humanTraining_examination: '考取',
  humanTraining_max_score: "分（{examCountNum}次機會）",
  humanTraining_exam_again: '重新考試',
  humanTraining_go_exam: '去考試',
  humanTraining_no_brief_intro:"暫無簡介",
  humanTraining_empty_training_program:'還沒有培訓項目',
  humanTraining_training_program_end:'培訓項目已結束!',
  humanTraining_training_duration:'培訓學時',
  humanTraining_total_time:'共{periodTotal}個學時',
  humanTraining_total:'共',
  humanTraining_sheng:'剩'
}
